exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table{width:100%!important;font-size:12px!important}.custom{width:100%;border-collapse:collapse}.custom tbody tr td,.custom thead tr th{padding-left:2px}table thead tr th{background-color:#d3d3d3;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e95a600","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DC/fypPrint.vue
// module id = 368
// module chunks = 0